// Tema claro/oscuro del dashboard "INDICADORES". Dos piezas que trabajan juntas:
// 1. Variables CSS --dsi-* definidas en el contenedor raíz de la página (views/dashboard-sale-
//    indicators/index.vue) según la clase .dsi-page--dark / .dsi-page--light — todas las cards,
//    tablas, selects y botones las usan (con el valor del tema claro como respaldo), así que
//    cambian solas al cambiar la clase.
// 2. ApexCharts NO lee CSS (dibuja SVG con los colores que se le pasen por opciones): cada gráfica
//    usa themeMixin con los mismos colores en JS y se REMONTA al cambiar el tema (su :key incluye el
//    tema).
//
// El tema se guarda en localStorage y sobrevive al cierre de sesión (ver THEME_STORAGE_KEY en
// util/sessionStorageCleanup.js, que debe listar esta misma llave).
import { mapState } from 'vuex'

export const THEME_STORAGE_KEY = 'dashboard_sale_indicators_theme'

// Colores de ApexCharts por tema (los de las series — azul, verde, naranja... — son los mismos en
// los dos temas). cardBg se usa para el borde entre porciones de dona/treemap (que se vean
// "recortadas" con el color de la card y no con blanco).
export const THEMES = {
    light: { text: '#32325d', muted: '#525f7f', axis: '#6b7280', grid: '#f1f1f1', cardBg: '#ffffff' },
    dark: { text: '#e6edf7', muted: '#a0aec0', axis: '#a0aec0', grid: '#2a3446', cardBg: '#161f2e' }
}

export function loadTheme() {
    try {
        const saved = localStorage.getItem(THEME_STORAGE_KEY)

        return saved === 'light' || saved === 'dark' ? saved : 'dark'
    } catch (e) {
        return 'dark'
    }
}

export function saveTheme(theme) {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme)
    } catch (e) {
        // Sin storage: el tema solo dura la sesión, no es crítico.
    }
}

export const themeMixin = {
    computed: {
        ...mapState('dashboard_sale_indicators', ['theme']),
        isDark() {
            return this.theme === 'dark'
        },
        themeColors() {
            return THEMES[this.theme] || THEMES.dark
        },
        // Opciones base de ApexCharts para chart: { ... } — fondo transparente (se ve el de la card)
        // y color de ejes/leyendas del tema.
        apexThemeOptions() {
            return { background: 'transparent', foreColor: this.themeColors.axis }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/dashboard-sale-indicators/theme.js